// src/lib/dialogs.ts
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/dialogs.css";

const MySwal = withReactContent(Swal);

type Icon = "warning" | "question" | "info" | "error" | "success";

export async function confirm(opts: {
  title: string;
  text?: string;
  confirmText?: string;
  cancelText?: string;
  icon?: Icon;
}): Promise<boolean> {
  const res = await MySwal.fire({
    title: opts.title,
    text: opts.text,
    icon: opts.icon ?? "question",
    showCancelButton: true,
    confirmButtonText: opts.confirmText ?? "Confirmar",
    cancelButtonText: opts.cancelText ?? "Cancelar",
    reverseButtons: true,
    buttonsStyling: false,
    customClass: {
      popup: "tm-swal-popup",
      title: "tm-swal-title",
      htmlContainer: "tm-swal-text",
      confirmButton: "tm-swal-btn tm-swal-btn-primary",
      cancelButton: "tm-swal-btn tm-swal-btn-ghost",
    },
    width: "min(460px, 92vw)",
    backdrop: true,
  });
  return res.isConfirmed === true;
}

export async function alertSuccess(title: string, text?: string) {
  await MySwal.fire({
    icon: "success",
    title,
    text,
    buttonsStyling: false,
    customClass: {
      popup: "tm-swal-popup",
      title: "tm-swal-title",
      htmlContainer: "tm-swal-text",
      confirmButton: "tm-swal-btn tm-swal-btn-primary",
    },
    width: "min(460px, 92vw)",
  });
}

export async function alertError(title: string, text?: string) {
  await MySwal.fire({
    icon: "error",
    title,
    text,
    buttonsStyling: false,
    customClass: {
      popup: "tm-swal-popup",
      title: "tm-swal-title",
      htmlContainer: "tm-swal-text",
      confirmButton: "tm-swal-btn tm-swal-btn-primary",
    },
    width: "min(460px, 92vw)",
  });
}
